import React from "react";
import "./HeaderSkeleton.scss";

/**
 * HeaderSkeleton
 * @returns {JSX.Element} Skeleton header UI
 */
const HeaderSkeleton = () => {
  return (
    <div className="top-header header-skeleton">
      <div className="header-skeleton__left">
        <div className="skeleton-box skeleton-box--hamburger" />
        <div className="skeleton-box skeleton-box--logo" />
      </div>

      <div className="skeleton-box skeleton-box--agency-logo" />

      <div className="header-skeleton__right">
        <div className="skeleton-box skeleton-box--notification" />
        <div className="skeleton-box skeleton-box--profile" />
      </div>
    </div>
  );
};

export default HeaderSkeleton;